import { authGet } from "@api";

import { TokensResponse } from "@pages/settings/types";

export const getTokens = (deploymentId: string): Promise<TokensResponse> => {
  const path = `/api/agent/deployments/${deploymentId}/tokens`;
  return authGet<TokensResponse>(path);
};
